export default {
  path: '/equipments',
  redirect: '/equipments/qr_code_scan',
  component: () => import('@/layouts/PublicLayout'),
  children: [
    {
      path: 'qr_code_scan',
      component: () => import('@/views/equipments/actives/QrCodeScan'),
      meta: {
        title: '设备激活'
      }
    },
    {
      path: ':serial_number/confirm_equipment',
      component: () => import('@/views/equipments/actives/ConfirmEquipment'),
      meta: {
        title: '设备激活'
      }
    },
    {
      path: ':serial_number/input_contact_info',
      component: () => import('@/views/equipments/actives/InputContactInfo'),
      meta: {
        title: '设备激活'
      }
    },
    {
      path: ':serial_number/connection_test',
      component: () => import('@/views/equipments/actives/ConnectionTest'),
      meta: {
        title: '设备激活'
      }
    },
    {
      path: ':serial_number/detail',
      component: () => import('@/views/equipments/detail/Detail'),
      meta: {
        title: '设备信息'
      }
    },
    {
      path: ':id/detailInfo',
      component: () => import('@/views/equipments/detail/Info'),
      meta: {
        title: '设备详情信息'
      }
    },
    {
      path: ':id/joinGroup',
      component: () => import('@/views/equipments/detail/JoinGroup'),
      meta: {
        title: '家庭二维码'
      }
    },
    {
      path: ':id/applyPublic',
      component: () => import('@/views/equipments/detail/ApplyPublic'),
      meta: {
        title: '对外共享充电'
      }
    }
  ]
}
